import { composeStyle } from '@xhs/yam-beer/core/system/compose'
import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.divider', {
      wrapper: {
        height: composeStyle.when('vertical')
          .truthy('auto')
          .falsy('1px'),
        width: composeStyle.when('vertical')
          .truthy('1px')
          .falsy('auto'),
        hairline: composeStyle.when('vertical')
          .truthy({
            transform: 'scale(0.5, 1)',
            transformOrigin: '50% 100%',
          })
          .falsy({
            transform: 'scale(1, 0.5)',
            transformOrigin: '100% 50%',
          }),
      },
      content: {
        background: 'white',
        display: 'inline-block',
        px: 12,
      },
    }),
  ]
}
